export default __webpack_public_path__ + "static/media/Sage's Mask of the Three Clarities.450ae9b1.jpg";